import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';

class MapHandlerAndIntent extends Component {

    constructor() {
        super();
        this.state = {
            intentId: null,
            handlerId: null,
            handlerName: null,
            showLoader: false
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchHandlerMappingDetailsApi();
        }, 300);
        var handlerName = this.props.location.state.handlerName
        this.setState({ handlerName: handlerName })
    }

    notifyFailToCreate(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    fetchHandlerMappingDetailsApi = () => {
        let HandlerMappingDetailsController = this;
        let handlerId = HandlerMappingDetailsController.props.location.state.handlerId;
        let data = {
            handlerId: handlerId,
            projectId: localStorage.getItem("currentProjectId"),
        }
        $.ajax({
            url: "/api/dsm-mapping",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    HandlerMappingDetailsController.state.handlerId = res.result.handlerId;
                    HandlerMappingDetailsController.state.intentId = res.result.intentId;
                    HandlerMappingDetailsController.state.showLoader = true;
                    HandlerMappingDetailsController.setState(HandlerMappingDetailsController.state);
                    HandlerMappingDetailsController.fetchSLUApi(res.result.intentId);
                }
                else {
                    HandlerMappingDetailsController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchSLUApi = (id) => {
        var HandlerMappingDetailsController = this;
        HandlerMappingDetailsController.state.domainId = this.props.location.state.domainId
        $.ajax({
            url: "/api/slu-intent",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId"),
                "domainId": HandlerMappingDetailsController.state.domainId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var sluList = res.result
                    for (var i = 0; i < sluList.length; i++) {
                        if (id === sluList[i].id) {
                            HandlerMappingDetailsController.state.intentName = sluList[i].name;
                            HandlerMappingDetailsController.setState(HandlerMappingDetailsController.state);
                        }
                    }
                }
                else {
                    HandlerMappingDetailsController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }


    editMapping = () => {
        var domainId = this.props.location.state.domainId;
        var handlerId = this.state.handlerId
        this.props.history.push({
            pathname: "/projectmgmt/map-handler-and-intent",
            state: {
                domainId: domainId, handlerId: handlerId,
                previousCompPath: this.props.location.state.previousCompPath
            }
        });
    }

    goBack = () => {
        if (this.props.location.state.previousCompPath == "dsm") {
            this.props.history.push({
                pathname: "/projectmgmt/nlutab/dsm",
                state: { goBackToDsm: true }
            });
        } else {
            this.props.history.push({
                pathname: "/projectmgmt/nlutab/dsm/dsm-graphs",
                state: { goBackToDsm: true }
            });
        }
    }

    render() {
        return (
            <div className="row col-md-12 p-0 m-0">
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>
                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />

                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="wrapper" style={{ backgroundColor: "White" }}>
                        <div className="content-wrapper" style={{ backgroundColor: "White" }}>
                            <ToastContainer className="Toast-at-center" />

                            <h6 className="taglineTxt">
                                <img className="cursor-change" src="./assets/images/arrow.svg"
                                    onClick={this.goBack}
                                    style={{ width: '24px', marginTop: '20px' }} /></h6>
                            <h1 className="m-0 page-title">Handler Mapping Details</h1><br /><br />

                            <button className="btn action-button" style={{ marginLeft: "80%" }}
                                title="Edit" onClick={this.editMapping}>
                                <img className="img-responsive cursor-change"
                                    src="./assets/images/editWithWhiteFilled.png"
                                /></button>
                            <br /><br /> <p>Intent Name :&nbsp;&nbsp;{this.state.intentName}</p><br />
                            <p>Intent Id:&nbsp;&nbsp;{this.state.intentId}</p><br />
                            <p>Handler Name:&nbsp;&nbsp;{this.state.handlerName}</p><br />
                            <p>Handler Type:&nbsp;&nbsp;{this.props.location.state.previousCompPath == "dsm" ? "DST" : "DWF"}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MapHandlerAndIntent;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/transition/HandlerMappingDetails.js